import React, { Component } from 'react'
import { connect } from 'react-redux'

import { DetallesSiloDialogView } from '../components/DetallesSiloDialogView'

class DetallesSiloDialog extends Component {
  render () {
    const { silo } = this.props
    return (
      <DetallesSiloDialogView
        silo={silo}
      />
    )
  }
}

const mapStateToProps = state => {
  return {
    silo: state.cuadroDeMandoMovimientos.detallesMovimientosSilo
  }
}
export default connect(mapStateToProps)(DetallesSiloDialog)
